export default __webpack_public_path__ + "static/img-2-b53de27f4b144f34e8152b4eff3eb924.png";